<script lang="ts">
  interface Hotspot {
    region: string;
    x: number;
    y: number;
    ordersCount: number;
    popularCategory: string;
  }

  let { hotspots = [] }: { hotspots: Hotspot[] } = $props();
  let activeSpot = $state<Hotspot | null>(null);
</script>

<div class="p-6 bg-base-100 border border-base-300 rounded-2xl flex flex-col justify-between">
  <div>
    <h3 class="text-sm font-bold uppercase tracking-wider text-base-content/70">Geographic Fulfillment Hotspots</h3>
    <p class="text-xs text-base-content/50 mb-4">Interactive delivery nodes mapping customer demographics</p>

    <div class="relative bg-base-200/50 rounded-xl overflow-hidden border border-base-300 h-44 flex items-center justify-center">
      <svg viewBox="0 0 300 200" class="w-full h-full">
        <defs>
          <pattern id="mapPattern" width="16" height="16" patternUnits="userSpaceOnUse">
            <circle cx="8" cy="8" r="1" class="fill-base-content/5" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#mapPattern)" />

        {#each hotspots as spot}
          {@const isActive = activeSpot?.region === spot.region}
          <!-- svelte-ignore a11y_no_static_element_interactions -->
          <g role="graphics-symbol" class="cursor-pointer group" onmouseenter={() => activeSpot = spot} onmouseleave={() => activeSpot = null}>
            {#if spot.ordersCount > 0}
              <circle cx={spot.x} cy={spot.y} r={isActive ? 12 : 6} class="fill-none stroke-accent/40 animate-pulse" stroke-width="1.5" />
            {/if}
            <circle cx={spot.x} cy={spot.y} r={isActive ? 5 : 3.5} class="fill-accent transition-all duration-300 group-hover:scale-125" />
            <text x={spot.x} y={spot.y - 8} class="text-[8px] font-bold fill-base-content/40 text-center select-none" text-anchor="middle">
              {spot.region}
            </text>
          </g>
        {/each}
      </svg>

      {#if activeSpot}
        <div class="absolute bottom-2 right-2 bg-base-100/90 border border-base-300 p-2.5 rounded-lg shadow-xl text-left text-[10px] space-y-1 backdrop-blur-sm animate-fade-in">
          <p class="font-extrabold uppercase text-accent leading-none">{activeSpot.region}</p>
          <p class="font-semibold text-base-content">{activeSpot.ordersCount} Orders registered</p>
          <p class="text-base-content/65">Top flow: {activeSpot.popularCategory}</p>
        </div>
      {/if}
    </div>
  </div>
</div>
